import { Pipe, PipeTransform } from '@angular/core';

import * as _ from 'lodash';

import { CountriesService } from 'src/app/shared/services/countries.service';

@Pipe({
  name: 'countryName',
  pure: false,
  standalone: false,
})
export class CountryNamePipe implements PipeTransform {
  private _country: any;

  constructor(private countriesService: CountriesService) {}

  transform(countryCode: string): string {
    if (this._country && this._country.code === countryCode) {
      return this._country.name;
    }

    this._country = _.find(this.countriesService.countries, {
      code: countryCode,
    });

    return (this._country && this._country.name) || countryCode;
  }
}
